import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SecondsToTimePlayerPipe } from '../../player/pipes/seconds-to-time-player.pipe';
import { PlayerSeekbarPipe } from '../../player/player-seekbar/player-seekbar.pipe';
import { ContentTypePipe } from './content-type/content-type.pipe';
import { ImageAspectRatioPipe } from './image-aspect-ratio/image-aspect-ratio.pipe';
import { MetaListPipe } from './meta-list/meta-list.pipe';
import { ProgramPaddingPipe } from './program-padding/program-padding.pipe';
import { SizePipe } from './size/size.pipe';
import { TruncateTextPipe } from './truncate-text/truncate-text.pipe';
import { TtsConcat } from './tts-concat/tts-concat.pipe';
import { TtsTranslatePipe } from './tts-translate/tts-translate.pipe';


@NgModule({
  declarations: [
    ContentTypePipe,
    ImageAspectRatioPipe,
    MetaListPipe,
    TruncateTextPipe,
    SizePipe,
    ProgramPaddingPipe,
    PlayerSeekbarPipe,
    SecondsToTimePlayerPipe,
    TtsTranslatePipe,
    TtsConcat,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ContentTypePipe,
    ImageAspectRatioPipe,
    MetaListPipe,
    TruncateTextPipe,
    SizePipe,
    ProgramPaddingPipe,
    PlayerSeekbarPipe,
    SecondsToTimePlayerPipe,
    TtsTranslatePipe,
    TtsConcat
  ]
})
export class PipesModule { }
